/**
 * Compute SHA-256 hash of a file
 * @param {File} file - The file to hash
 * @returns {Promise<string>} - Hex string representation of the hash
 */
export const computeFileHash = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = async (event) => {
      try {
        const arrayBuffer = event.target.result;
        const hashBuffer = await crypto.subtle.digest('SHA-256', arrayBuffer);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
        
        console.log(`[Crypto] SHA-256 computed for ${file.name}: ${hashHex}`);
        resolve(hashHex);
      } catch (error) {
        console.error(`[Crypto] Failed to compute hash for ${file.name}:`, error);
        reject(error);
      }
    };
    
    reader.onerror = () => {
      console.error(`[Crypto] Failed to read file for hashing: ${file.name}`);
      reject(new Error('Failed to read file for hashing'));
    };
    
    reader.readAsArrayBuffer(file);
  });
};

/**
 * Generate a unique image ID based on SHA-256 hash
 * @param {File} file - The image file
 * @returns {Promise<string>} - SHA-256 hash as image ID
 */
export const generateImageId = async (file) => {
  return await computeFileHash(file);
};